module.exports = __webpack_public_path__ + "6bf1e6673a1011b3888c22a6c0adbd8a.pdf";